// Hidden House Co. — Theme JS

// Personalization character counter
document.querySelectorAll('[data-char-limit]').forEach(input => {
  const limit = parseInt(input.dataset.charLimit, 10);
  const counter = input.nextElementSibling;
  if (!counter) return;
  counter.textContent = `0 / ${limit} characters`;
  input.addEventListener('input', () => {
    if (input.value.length > limit) input.value = input.value.slice(0, limit);
    counter.textContent = `${input.value.length} / ${limit} characters`;
  });
});

// Cart quantity controls
function setCartItemQuantity(key, newQty, countEl) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  })
    .then(r => r.json())
    .then(cart => {
      if (newQty === 0) {
        document.querySelector(`.cart-item[data-key="${key}"]`)?.remove();
      } else {
        countEl.value = newQty;
        countEl.dataset.qty = newQty;
        const item = cart.items.find(i => i.key === key);
        if (item) {
          const priceEl = document.querySelector(`.cart-item__price[data-key="${key}"]`);
          if (priceEl) priceEl.textContent = (item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
        }
      }
      const subtotalEl = document.getElementById('cart-subtotal');
      if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
      if (cart.item_count === 0) location.reload();
    });
}

document.querySelectorAll('.cart-qty__btn').forEach(btn => {
  btn.addEventListener('click', () => {
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const countEl = document.querySelector(`.cart-qty__count[data-key="${key}"]`);
    if (!countEl) return;
    const current = parseInt(countEl.value, 10) || 0;
    const newQty = action === 'increase' ? current + 1 : Math.max(0, current - 1);
    setCartItemQuantity(key, newQty, countEl);
  });
});

document.querySelectorAll('.cart-qty__count').forEach(input => {
  const key = input.dataset.key;
  const commitQuantity = () => {
    let newQty = parseInt(input.value, 10);
    if (isNaN(newQty) || newQty < 0) newQty = parseInt(input.dataset.qty, 10) || 0;
    if (newQty === parseInt(input.dataset.qty, 10)) {
      input.value = newQty;
      return;
    }
    setCartItemQuantity(key, newQty, input);
  };
  input.addEventListener('change', commitQuantity);
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      input.blur();
    }
  });
});

// Cart remove buttons
document.querySelectorAll('.cart-item__remove').forEach(btn => {
  btn.addEventListener('click', () => {
    const key = btn.dataset.key;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(r => r.json())
      .then(cart => {
        document.querySelector(`.cart-item[data-key="${key}"]`)?.remove();
        const subtotalEl = document.getElementById('cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
        if (cart.item_count === 0) location.reload();
      });
  });
});

// Product image gallery
document.querySelectorAll('.product-page__thumb').forEach(thumb => {
  thumb.addEventListener('click', () => {
    const fullSrc = thumb.dataset.full;
    const fullSrcset = thumb.dataset.srcset;
    if (!fullSrc) return;
    const media = thumb.closest('.product-page__media');
    const mainImg = media?.querySelector('.product-page__main-image img');
    if (mainImg) {
      mainImg.src = fullSrc;
      if (fullSrcset) mainImg.srcset = fullSrcset;
    }
    media?.querySelectorAll('.product-page__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  });
});
